var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('z-menu'),(!_vm.acceptedCookies)?_c('cookies-banner'):_vm._e(),_c('b-container',{staticClass:"no-gutters px-0",attrs:{"fluid":""}},[_c('router-view')],1),_c('z-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }